import { render, staticRenderFns } from "./bankCertification.vue?vue&type=template&id=48f89b24&scoped=true&"
import script from "./bankCertification.vue?vue&type=script&lang=js&"
export * from "./bankCertification.vue?vue&type=script&lang=js&"
import style0 from "./bankCertification.vue?vue&type=style&index=0&id=48f89b24&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f89b24",
  null
  
)

export default component.exports